import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { GetCostReviewListRequest } from '../models/GetCostReviewListRequest';
import { GetCostReviewListResponse } from '../models/GetCostReviewListResponse';
import { TRRThresholds } from '../models/TRRThresholds';
import { HttpCallsService } from './http-calls.service';
import { CostReviewParameters } from '../models/CostReviewParameters';
import { CostReviewApproveRequest, CostReviewDenyRequest, CostReviewUpdateTRRStatusRequest } from '../models/CostReviewOperationsRequest';
import { CostReviewApproveResponse, CostReviewDenyResponse, CostReviewUpdateTRRStatusResponse } from '../models/CostReviewOperationsResponse';
import { ReportsResponse} from '../models/ReportsResponse';
import { ReportsRequest } from '../models/ReportsRequest';
import { DelegateDataSource} from '../models/DelegateManagerPrivilegeResponse';
import { DelegateRequest } from '../models/DelegateManagerPrivilegeRequest';
import { UserLinkingMappingRequest, UserLinkingResponseBase } from '../models/UserLinkingResponse';
import { SearchEstimateRequest } from '../models/SearchEstimaterequest';
import { SearchEstimateResponse } from '../models/SearchEstimateResponse';
import { EstimateAssignOwnerRequest } from '../models/EstimateAssignOwnerRequest';
import { EstimateAssignOwnerResponse } from '../models/EstimateAssignOwnerResponse';
import { EstimateUserPreferences } from '../models/EstimateUserPreferences';
import { IntialControlDataResponse, UserDetailResponse, UserInfoResponse } from '../models/UsersResponse';
import { UserStatusResponse } from '../models/UserStatusResponse';
import { ReleaseEditAccessRequest } from '../models/ReleaseEditAccessRequest';
import { ReleaseEditAccessResponse } from '../models/ReleaseEditAccessResponse';
import { DisableRemovedUsersRequest } from '../models/DisableRemovedUsersRequest';
import { AllMasterData } from '../models/AllMasterData';
import { UserListRequest } from '../models/UserListRequest';
import { RemoveUserRequest } from '../models/RemoveUserRequest';
import { UsersAndSalesOfices } from '../models/UsersAndSalesOfices';
import { ReviewObject } from '../assets/review-object';
import { MasterAllData } from '../assets/master-all-data';

@Injectable({
  providedIn: 'root'
})
export class ApiMethodsService {

  constructor(private httpCallsService : HttpCallsService) { }

  mtApiUri = {
      loginService: "baseURL" + '/Login', 
      costReviewService: "baseURL" + '/CostReview',
      estimateService: "baseURL" + '/Estimates',
      generalConfigService: "baseURL" + '/GeneralConfigurations', 
      reports: "baseURL" + '/Reports',
      userManagement: "baseURL" + '/UserManagement',
      toolsMenu: "baseURL" + '/ToolsMenu',
  }

  //#region COST REVIEW
  getReviewList(requestObj: GetCostReviewListRequest): Observable<GetCostReviewListResponse> {
    return this.httpCallsService.httpPostService(`${this.mtApiUri.costReviewService}/GetCostReviews`, requestObj);
  }

  exportCostReviewList(request: GetCostReviewListRequest): Observable<Blob> {
    return this.httpCallsService.httpPostService(`${this.mtApiUri.costReviewService}/ExportReviewList`, request, {
      responseType: 'blob' as 'json'
    });
  }

  approveCostReview(request: CostReviewApproveRequest): Observable<CostReviewApproveResponse> {
    return this.httpCallsService.httpPostService(`${this.mtApiUri.costReviewService}/ApproveCostReview`, request);
  }

  denyCostReview(request: CostReviewDenyRequest): Observable<CostReviewDenyResponse> {
    return this.httpCallsService.httpPostService(`${this.mtApiUri.costReviewService}/DenyCostReview`, request);
  }

  updateReviewTRRStatus(request: CostReviewUpdateTRRStatusRequest) : Observable<CostReviewUpdateTRRStatusResponse>{
    return this.httpCallsService.httpPostService(`${this.mtApiUri.costReviewService}/UpdateTRRStatus`, request);
  }

  //#endregion COST REVIEW

  //#region ESTIMATES





  getEstimatesList(payload: SearchEstimateRequest): Observable<SearchEstimateResponse> {
    return this.httpCallsService.httpPostService(`${this.mtApiUri.estimateService}/GetEstimatesList`, payload);
  }

  assignNewOwner(payload: EstimateAssignOwnerRequest): Observable<EstimateAssignOwnerResponse> {
    return this.httpCallsService.httpPostService(`${this.mtApiUri.estimateService}/AssignNewOwner`, payload);
  }

  releaseEditAccess(payload: ReleaseEditAccessRequest): Observable<ReleaseEditAccessResponse>{
    return this.httpCallsService.httpPostService(`${this.mtApiUri.estimateService}/ReleaseEditAccess`, payload);
  }
  
  //#endregion ESTIMATES

  getTRRThresholds(): Observable<TRRThresholds> {
    return this.httpCallsService.httpGetService(`${this.mtApiUri.generalConfigService}/GetTRRThresholds`);
  }

  getCostReviewParameters(): Observable<CostReviewParameters[]> {
    return this.httpCallsService.httpGetService(`${this.mtApiUri.generalConfigService}/GetCostReviewParameters`);
  }

  getAllMasterData(): Observable<AllMasterData> {
    return of(MasterAllData as unknown as AllMasterData);
    // return this.httpCallsService.httpGetService(`${this.mtApiUri.generalConfigService}/GetAllMasterData`);
  }

  mtLogin(idToken : any): Observable<any> {
    return this.httpCallsService.httpPostService(`${this.mtApiUri.loginService}/Login`, JSON.stringify(idToken));    
  }

  getUsersCountryAndUserLevelList(): Observable<IntialControlDataResponse> {
    return this.httpCallsService.httpGetService(`${this.mtApiUri.userManagement}/GetUserPreLoadControlsData`);
  }

  getUserList(requestObj: UserListRequest): Observable<UsersAndSalesOfices> {
    return this.httpCallsService.httpPostService(`${this.mtApiUri.userManagement}/GetListOfUsersAndSalesOffices`, requestObj);
  }

  getUserDetails(requestObj: {bsetUserId: string}): Observable<UserDetailResponse> {
    return this.httpCallsService.httpPostService(`${this.mtApiUri.userManagement}/GetUserDetails`, requestObj);
  }

  createUser(emailId: string): Observable<UserInfoResponse> {
    return this.httpCallsService.httpPostService(`${this.mtApiUri.userManagement}/GetZidByEmailId`, {emailId});
  }

  removeUser(requestObj: RemoveUserRequest): Observable<{isUserRemoved: boolean}> { 
    return this.httpCallsService.httpPostService(`${this.mtApiUri.userManagement}/RemoveUser`, requestObj); 
   }

   saveOrUpdateUser(requestObj: UserDetailResponse): Observable<{userId: number}> {
    return this.httpCallsService.httpPostService(`${this.mtApiUri.userManagement}/SaveOrUpdateUser`, requestObj);
   }

  //#region Check User Status
  
  getActiveDirectoryUsers(): Observable<UserStatusResponse> {
    return this.httpCallsService.httpGetService(`${this.mtApiUri.toolsMenu}/GetUserStatus`);
  }

  disableRemovedUsers(requestObj: DisableRemovedUsersRequest): Observable<boolean> {
    return this.httpCallsService.httpPostService(`${this.mtApiUri.toolsMenu}/DisableRemovedUsers`, requestObj);
  }

 //#endregion Check User Status

  //#region Delegation
  getDelegationDetail(): Observable<DelegateDataSource> {
    return this.httpCallsService.httpGetService(`${this.mtApiUri.toolsMenu}/GetDelegationDetails`);
  }

  addDelegationDetail(request: DelegateRequest) {
    return this.httpCallsService.httpPostService(`${this.mtApiUri.toolsMenu}/UpsertDelegation`, request);
  }

  deleteDelegationDetail(): Observable<any> {
    return this.httpCallsService.httpPostService(`${this.mtApiUri.toolsMenu}/RemoveDelegation`,null);
  }
  //#endregion Delegation
  //#region Reports
  getUsersReport(isActive: ReportsRequest): Observable<ReportsResponse> {
    return this.httpCallsService.httpPostService(`${this.mtApiUri.reports}/GetUsersReport`,isActive); 
  }

  getManagersReport(isActive: ReportsRequest): Observable<ReportsResponse> {
    return this.httpCallsService.httpPostService(`${this.mtApiUri.reports}/GetManagersReport`,isActive);
  }

  getUnknownUsersReport(): Observable<ReportsResponse> {
    return this.httpCallsService.httpGetService(`${this.mtApiUri.reports}/GetUnknownUsersReport`);
  }

  getUserStatusReport(): Observable<ReportsResponse> {
    return this.httpCallsService.httpGetService(`${this.mtApiUri.reports}/GetUsersStatusReport`);
  }

  getUserActivityReport(): Observable<ReportsResponse> {
    return this.httpCallsService.httpGetService(`${this.mtApiUri.reports}/GetUserActivityReport`);
  }

  getLocaleSummaryReport(): Observable<ReportsResponse> {
    return this.httpCallsService.httpGetService(`${this.mtApiUri.reports}/GetLocaleSummaryReport`);
  }
   //#endregion Reports

   //#region User Linking
  getUserDataForMapping(): Observable<UserLinkingResponseBase> {
    return this.httpCallsService.httpGetService(`${this.mtApiUri.toolsMenu}/GetUserDataForMapping`);
  }

  setUserMapping(requestObj: UserLinkingMappingRequest) {
    return this.httpCallsService.httpPostService(`${this.mtApiUri.toolsMenu}/SetUserMapping`, requestObj);
  }

  //#endregion User Linking

}
